import { TdsButton } from '@scania/tegel-react'
import styled from 'styled-components'

export const StyledTdsButton = styled(TdsButton)`
  min-width: 90px;
  white-space: nowrap;
`
